var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDeclineRequest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62.898,
    height: 45.639,
    viewBox: "0 0 62.898 45.639",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.079 45.64h-17.26C10.218 45.64 0 35.422 0 22.82S10.217 0 22.82 0h17.259c12.603 0 22.82 10.217 22.82 22.82s-10.217 22.82-22.82 22.82z",
    stroke: "#4E5567",
    strokeWidth: 1.29,
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#A8AEBC",
    strokeLinecap: "round",
    strokeWidth: 3.148
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25.767 28.525 11.364-11.41M25.731 17.15 37.167 28.49"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeclineRequest);
export default __webpack_public_path__ + "static/media/ic_decline_request.3068b28cc5422f61a795e6f9b17b1c8d.svg";
export { ForwardRef as ReactComponent };